var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranching(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1V9.5C1.5 10.9001 1.5 11.6002 1.77248 12.135C2.01217 12.6054 2.39462 12.9878 2.86502 13.2275C3.3998 13.5 4.09987 13.5 5.5 13.5H11.5M11.5 13.5C11.5 14.8807 12.6193 16 14 16C15.3807 16 16.5 14.8807 16.5 13.5C16.5 12.1193 15.3807 11 14 11C12.6193 11 11.5 12.1193 11.5 13.5ZM1.5 5.16667L11.5 5.16667M11.5 5.16667C11.5 6.54738 12.6193 7.66667 14 7.66667C15.3807 7.66667 16.5 6.54738 16.5 5.16667C16.5 3.78595 15.3807 2.66667 14 2.66667C12.6193 2.66667 11.5 3.78596 11.5 5.16667Z",
    stroke: "#0D121C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranching);
export default __webpack_public_path__ + "static/media/branching.a49372efa3e3065db64a32811cbc7b68.svg";
export { ForwardRef as ReactComponent };